"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chat = void 0;
class Chat {
    constructor(data) {
        this.title = data.title;
        this.administration = data.administration;
        this.created = data.created;
        this.last_active = data.last_active;
        this.reference = data.reference;
        this.viewable_by_filter = data.viewable_by_filter;
        this.person_status_filter = data.person_status_filter;
        this.rooms = data.rooms;
        this.users = data.users;
        this.show_for = data.show_for || [...(data.users || []), ...(data.administration || [])];
        this.usersMetadata = data.usersMetadata;
        // this.last_message = data.last_message;
        this.deny_members = !!data.deny_members;
        this.allow_parents = !!data.allow_parents;
    }
    static new(data) {
        const chatData = {
            administration: [],
            created: new Date(),
            last_active: new Date(),
            reference: undefined,
            rooms: [],
            viewable_by_filter: {},
            person_status_filter: {},
            users: [],
            usersMetadata: [],
        };
        if (data) {
            Object.keys(data).forEach((key) => {
                // already have checks that key is in both
                chatData[key] = data[key];
            });
        }
        return new this(chatData);
    }
    static fromQueryDocumentSnapshot(snapshot) {
        if (!snapshot.exists) {
            return undefined;
        }
        const chat = this.new(snapshot.data());
        chat._querySnap = snapshot;
        chat._ref = snapshot.ref;
        chat._parentId = snapshot.ref.parent.parent.id;
        return chat;
    }
    static fromQuerySnapshot(snapshot) {
        const chats = [];
        if (snapshot.empty) {
            return chats;
        }
        // eslint-disable-next-line no-restricted-syntax
        for (const d of snapshot.docs) {
            const chat = this.fromQueryDocumentSnapshot(d);
            if (chat) {
                chats.push(chat);
            }
        }
        return chats;
    }
    hasSubject() {
        return !!this.reference;
    }
    async getSubject() {
        if (this._subject) {
            return this._subject;
        }
        if (this.reference) {
            this._subject = this.reference
                .get()
                .then((feedPost) => feedPost.data().title);
            return this._subject;
        }
        return undefined;
    }
    getRaw() {
        const rawData = { ...this };
        Object.keys(rawData).forEach((key) => {
            if (key.startsWith('_')) {
                delete rawData[key];
            }
        });
        return rawData;
    }
    querySnap() {
        if (!this._querySnap) {
            throw new Error('Somehow querysnap does not exist! chat');
        }
        return this._querySnap;
    }
    ref() {
        if (!this._ref) {
            throw new Error('Somehow ref does not exist! chat');
        }
        return this._ref;
    }
    getId() {
        const qs = this.querySnap();
        if (!qs) {
            throw new Error('Somehow id does not exist! chat');
        }
        return qs.id;
    }
    parentID() {
        if (!this._parentId) {
            throw new Error('Somehow parentid does not exist! chat');
        }
        return this._parentId;
    }
}
exports.Chat = Chat;
//# sourceMappingURL=chat.js.map